import React, { useState } from "react";

import {
  Tooltip,
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";

// import { useMutation, useQuery } from "@apollo/client"
//icons
import { CiCircleList } from "react-icons/ci";
import { FaRegEye } from "react-icons/fa";
import { BiMinusCircle } from "react-icons/bi";

//src
import "../../../Style/dialogstyle.scss";
export default function ViewDelivery({ editData }) {
  return (
    <div>
      <Stack
        direction="column"
        spacing={2}
        sx={{ width: "100%" }}
        className="view-dialog-contanier"
      >
        <Stack direction="row" spacing={1} className="view-header">
          <Typography
            className="field-title-list"
            sx={{ width: "10%" }}
            align="center"
          >
            រូបភាព
          </Typography>
          <Typography className="field-title-list" sx={{ width: "30%" }}>
            ឈ្មោះសម្ភារៈ
          </Typography>
          <Typography className="field-title-list" sx={{ width: "30%" }}>
            ឯកតា
          </Typography>
          <Typography className="field-title-list" sx={{ width: "30%" }}>
            ចំនួន
          </Typography>
        </Stack>

        {editData?.deliveryTakeOutMaterial?.map((row, index) => {
          console.log("row2", row);
          return (
            <Stack direction="row" spacing={1} key={index}>
              <Stack width="10%" direction={`row`} justifyContent="center">
                <img
                  src={row?.listMaterialUnitId?.imageSrc}
                  alt=""
                  style={{
                    borderRadius: "5px",
                    objectFit: "cover",
                    width: "80%",
                  }}
                />
              </Stack>
              <Stack width="30%" direction="column" justifyContent="center">
                <Typography className="field-title" width="100%">
                  {row?.listMaterialUnitId?.materialId?.materialKhName}
                </Typography>
              </Stack>

              <Stack width="30%" direction="column" justifyContent="center">
                <Typography className="field-title" width="100%">
                  {row?.listMaterialUnitId?.unitId?.unitKhName}
                </Typography>
              </Stack>
              <Stack width="30%" direction="column" justifyContent="center">
                <Typography className="field-title" width="100%">
                  {row?.qty}
                </Typography>
              </Stack>
            </Stack>
          );
        })}
      </Stack>
    </div>
  );
}
